import { getConsentDetails, getConsentTrackingStatus } from './consentManager';

/**
 * Enrich at dispatch time; callers cannot override the current consent status or details.
 * `consentDetails` is only present once a CMP provider has recorded it - a caller-supplied
 * value is dropped either way, so a stale one can never slip through.
 */
export function withConsentStatus<T>(
  dispatch: (event: string, data: Record<string, unknown>) => T
): (event: string, data: Record<string, unknown>) => T {
  return (event, data) => {
    const { consentDetails: _ignored, ...callerData } = data;
    const consentDetails = getConsentDetails();
    return dispatch(event, {
      ...callerData,
      consentStatus: getConsentTrackingStatus(),
      ...(consentDetails !== undefined && { consentDetails }),
    });
  };
}
